module.exports = __webpack_public_path__ + "img/play_icon.e7ab25bb.svg";